import {loadExpenseDetails, loadCropsDetails} from './digidiary.service';
import {callAPI, handleAlert} from './sagaHelper';
import {getCustomerId, getCropId, getExpenseType} from './selectors';

import {
  DIGIDIARY_GET_EXPENSE,
  DIGIDIARY_SET_LOADER,
  DIGIDIARY_GET_FARM_DATA,
  DIGIDIARY_ADD_EDIT_EXPENSE,
  POP_DIGIDIARY_VIEW,
} from '../actions';
import {
  setExpenseTotalAction,
  setExpenseTypes,
} from '../actions/digiDiaryActions';

import {takeEvery, select, put, call} from 'redux-saga/effects';

export function* getExpenseData() {
  const customerId = yield select(getCustomerId);
  let cropId = yield select(getCropId);
  let expenseType = yield select(getExpenseType);

  let flag = true;
  let loadExpenses = null;
  yield put({type: DIGIDIARY_SET_LOADER, flag});

  if (!cropId) {
    let loadCrops = [];
    loadCrops = yield loadCropsDetails(customerId);
    cropId = loadCrops.data[0].cropId;
    loadExpenses = yield loadExpenseDetails(customerId, cropId);

    const dataObj = {
      crops: loadCrops?.data,
    };

    yield put({type: DIGIDIARY_GET_FARM_DATA, dataObj});
  } else {
    loadExpenses = yield loadExpenseDetails(customerId, cropId);
  }
  yield put(
    setExpenseTypes({field: 'expenseTypesData', value: loadExpenses.data})
  );

  if (expenseType) {
    yield put(
      setExpenseTotalAction({field: 'expenseType', value: expenseType})
    );
  }
  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
}

export function* addEditExpense({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  const userId = yield select(getCustomerId);
  const response = yield call(callAPI, {
    method: data.method,
    url: `/expense?customerId=${userId}`,
    data: {...data.payload},
  });
  if (response.statusCode && response.statusCode === 200) {
    yield call(handleAlert, {
      variant: 'success',
      type: 'addExpenseSuccess',
    });
    yield call(getExpenseData);
    data.method === 'patch' ? yield put({type: POP_DIGIDIARY_VIEW}) : null;
  } else {
    yield call(handleAlert, {
      variant: 'error',
      type: 'alertError',
    });
    flag = false;
    yield put({type: DIGIDIARY_SET_LOADER, flag});
  }
}

export function* getExpenseDataSaga() {
  yield takeEvery(DIGIDIARY_GET_EXPENSE, getExpenseData);
}
export function* addExpenseDataSaga() {
  yield takeEvery(DIGIDIARY_ADD_EDIT_EXPENSE, addEditExpense);
}
